import { Button, Grid } from '@mui/material';
import OtpInput from 'react-otp-input';
import theme from "../../constants/theme"
import ErrorMsg from '../ErrorMsg';
import "./index.css";
const MyOtpInput = ({ numberOfDigits, handleResendCode, otp, setOtp, disableResendBtn, error, handleRemoveError, setTimer, setDisableResendBtn }) => {
  return (
    <Grid container display={"flex"} justifyContent={"center"} alignItems={"center"}>
      <Grid item display={"flex"} justifyContent={"center"} alignItems={"center"} xs={12} py={1}>
        <OtpInput
          value={otp}
          onChange={(num) => {
            if (error) {
              handleRemoveError()
            }
            setOtp(num)
          }}
          numInputs={numberOfDigits}
          containerStyle={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center" }}
          renderInput={(props) => <input id='otp-input-field' {...props} style={{
            width: '40px',
            height: '40px',
            textAlign: 'center',
            fontSize: '16px',
            border: error ? "2px solid red" : "1px solid black"
          }}
          />}
          inputType={"tel"}
        />
      </Grid>
      {error ?
        <Grid py={1} item xs={12}>
          <ErrorMsg error={error} />
        </Grid>
        : null}
      <Grid item xs={12}>
        {!disableResendBtn ? <Button sx={{
          color: theme.colors.primaryDark,
          ':hover': {
            background: "none",
            textDecoration: "underline",
          },
          ':focus': {
            background: "none",
            textDecoration: "underline",
          },
        }} onClick={() => {
          setTimer(30);
          setDisableResendBtn(true)
          handleResendCode()
        }
        }>Resend Code</Button> : null}
      </Grid>
    </Grid>
  )
};

export default MyOtpInput;
